import { render, staticRenderFns } from "./LSpc.vue?vue&type=template&id=22066bc7&scoped=true&"
import script from "./LSpc.vue?vue&type=script&lang=js&"
export * from "./LSpc.vue?vue&type=script&lang=js&"
import style0 from "./LSpc.vue?vue&type=style&index=0&id=22066bc7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22066bc7",
  null
  
)

export default component.exports